import { render, staticRenderFns } from "./OperateBusiness.vue?vue&type=template&id=66f249e5&scoped=true"
import script from "./OperateBusiness.vue?vue&type=script&lang=js"
export * from "./OperateBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f249e5",
  null
  
)

export default component.exports